/**
 * @module websocket.event.handlers.airlines.airline-updated
 */
import { store } from '../../../../state/store'
import { setAirlineItemUpdated } from '../../../../state/websocket.slice'

export default function handleAirlineUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirlineUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirlineItemUpdated(data))
  }
} 